import OfferType from './OfferType';
import OverlappingErrorAlert from './OverlappingErrorAlert';
import OfferKind from './OfferKind';
import CreateOfferDetails from './CreateOfferDetails';
import OfferLabel from './OfferLabel';
import WeekdayOffer from './WeekdayOffer';
import ManageAllOffers from './ManageAllOffers';
import OfferDetails from './OfferDetails';
import RenameOfferModal from './RenameOfferModal';

export default {
  OfferType,
  OfferKind,
  CreateOfferDetails,
  OfferLabel,
  OverlappingErrorAlert,
  WeekdayOffer,
  ManageAllOffers,
  OfferDetails,
  RenameOfferModal,
};
